import ICalculatorComponent from '@components/FormFlow/Interfaces/FormflowComponents/ICalculatorComponent';
import IConfirmComponent from '@components/FormFlow/Interfaces/FormflowComponents/IConfirmComponent';
import IDateComponent from '@components/FormFlow/Interfaces/FormflowComponents/IDateComponent';
import IDrawComponent from '@components/FormFlow/Interfaces/FormflowComponents/IDrawComponent';
import IGPSComponent from '@components/FormFlow/Interfaces/FormflowComponents/IGPSComponent';
import IMatrixComponent from '@components/FormFlow/Interfaces/FormflowComponents/IMatrixComponent';
import IModelComponent from '@components/FormFlow/Interfaces/FormflowComponents/IModelComponent';
import INumberComponent from '@components/FormFlow/Interfaces/FormflowComponents/INumberComponent';
import IPhotoComponent from '@components/FormFlow/Interfaces/FormflowComponents/IPhotoComponent';
import ISampleComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleComponent';
import ISampleImageComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleImageTaskComponent';
import ISampleTextComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleTextComponent';
import ISampleVideoComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISampleVideoComponent';
import IScoreComponent from '@components/FormFlow/Interfaces/FormflowComponents/IScoreComponent';
import ISelectAPIComponent from '@components/FormFlow/Interfaces/FormflowComponents/ISelectAPIComponent';
import ITextComponent from '@components/FormFlow/Interfaces/FormflowComponents/ITextComponent';
import ITreeViewComponent from '@components/FormFlow/Interfaces/FormflowComponents/ITreeViewComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import TaskIconDictionary from '@components/FormFlow/Util/TaskIconDictionary';
import { LocalStorageKeys } from '@containers/App';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, Row } from 'antd';
import React from 'react';

import { CalculatorComponent } from '../Content/TaskComponents/CalculatorTaskComponent';
import { ConfirmComponent } from '../Content/TaskComponents/ConfirmTaskComponent';
import { DateComponent } from '../Content/TaskComponents/DateTaskComponent';
import { DrawComponent } from '../Content/TaskComponents/DrawTaskComponent';
import { GoToComponent } from '../Content/TaskComponents/GoTotaskComponent';
import { GPSComponent } from '../Content/TaskComponents/GPSTaskComponent';
import { ModelComponent } from '../Content/TaskComponents/ModelTaskComponent';
import { NumberComponent } from '../Content/TaskComponents/NumberTaskComponent';
import PhotoTaskComponent, { PhotoComponent } from '../Content/TaskComponents/PhotoTaskComponent';
import { SampleImageComponent } from '../Content/TaskComponents/SampleImageTaskComponent';
import { SampleComponent } from '../Content/TaskComponents/SampleTaskComponent';
import { SampleTextComponent } from '../Content/TaskComponents/SampleTextTaskComponent';
import { SampleVideoComponent } from '../Content/TaskComponents/SampleVideoTaskComponent';
import { ScoreComponent } from '../Content/TaskComponents/ScoreTaskComponent';
import { SelectComponent } from '../Content/TaskComponents/SelectTaskComponent';
import { SelectTreeComponent } from '../Content/TaskComponents/SelectTreeViewComponent';
import { TextComponent } from '../Content/TaskComponents/TextTaskComponent';
import FormflowComponentItem from './FormflowComponentItem';
import FormflowLateralTitle from './FormflowLateralTitle';

interface IFormflowLateralMenuPropType {
};

interface IFormflowLateralMenuStateType {
  PhotoComponent: IPhotoComponent;
  ConfirmComponent: IConfirmComponent;
  DateComponent: IDateComponent;
  TextComponent: ITextComponent;
  NumberComponent: INumberComponent;
  GPSComponent: IGPSComponent;
  ModelComponent: IModelComponent;
  SampleTextComponent: ISampleTextComponent;
  SampleImageComponent: ISampleImageComponent;
  SampleVideoComponent: ISampleVideoComponent;
  SelectComponent: ISelectAPIComponent;
  GoToComponent: any;
  SampleComponent: ISampleComponent;
  TreeViewComponent: ITreeViewComponent;
  MatrixComponent?: IMatrixComponent;
  ScoreComponent?: IScoreComponent;
  CalculatorComponent?: ICalculatorComponent;
  DrawComponent?: IDrawComponent;
};

export default class FormflowLateralMenu extends React.Component<IFormflowLateralMenuPropType, IFormflowLateralMenuStateType> {
  private currentPillar: any;
  constructor(props: IFormflowLateralMenuPropType) {
    super(props);

    this.currentPillar = localStorage.getItem(LocalStorageKeys.PILLAR);
    this.state = {
      PhotoComponent: new PhotoComponent(),
      ConfirmComponent: new ConfirmComponent(),
      TextComponent: new TextComponent(),
      NumberComponent: new NumberComponent(),
      GPSComponent: new GPSComponent(),
      ModelComponent: new ModelComponent(),
      SampleTextComponent: new SampleTextComponent(),
      SampleImageComponent: new SampleImageComponent(),
      SampleVideoComponent: new SampleVideoComponent(),
      DateComponent: new DateComponent(),
      SelectComponent: new SelectComponent(),
      TreeViewComponent: new SelectTreeComponent(),
      GoToComponent: new GoToComponent(),
      ScoreComponent: new ScoreComponent(),
      SampleComponent: new SampleComponent(),
      CalculatorComponent: new CalculatorComponent(),
      DrawComponent: new DrawComponent()
    };


  }

  render() {
    const {
    } = this.props;
    return (
      <LateralMenuWrapper>
        <FormflowContext.Consumer>
          {({ currentSection }) => (
            <Row className="row">
              <Col className="lateralComponentsMenu" style={{ height: "100%" }}>
                <FormflowLateralTitle
                  titleText={I18n.l('formflow.components.title')}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.confirmComponent.titleConfirmComponent')}
                  icon={TaskIconDictionary.get(ComponentType.CONFIRM) as IconProp}
                  onClickComponent={this.state.ConfirmComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.textComponent.titleTextComponent')}
                  icon={TaskIconDictionary.get(ComponentType.TEXT) as IconProp}
                  onClickComponent={this.state.TextComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.photoComponent.titlePhotoComponent')}
                  icon={TaskIconDictionary.get(ComponentType.PHOTO) as IconProp}
                  onClickComponent={this.state.PhotoComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.numberComponent.titleNumberComponent')}
                  icon={TaskIconDictionary.get(ComponentType.NUMBER) as IconProp}
                  onClickComponent={this.state.NumberComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.dateComponent.titleDateComponent')}
                  icon={TaskIconDictionary.get(ComponentType.DATE) as IconProp}
                  onClickComponent={this.state.DateComponent}
                />
                {/* <FormflowComponentItem
                  title={I18n.l('formflow.components.gpsComponent.titleGPSComponent')}
                  icon={TaskIconDictionary.get(ComponentType.GPS) as IconProp}
                  onClickComponent={this.state.GPSComponent}
                /> */}
                {this.currentPillar != 'EHSS' && (
                <FormflowComponentItem
                  title={I18n.l('formflow.components.modelComponent.titleModelComponent')}
                  icon={TaskIconDictionary.get(ComponentType.MODEL) as IconProp}
                  onClickComponent={this.state.ModelComponent}
                />
                )}
                {/* <FormflowComponentItem
                                    title={I18n.l('formflow.components.timeComponent.titleTimeComponent')}
                                    icon={TaskIconDictionary.get(ComponentType.DURATION) as IconProp}
                                /> */}
                <FormflowComponentItem
                  title={I18n.l('formflow.components.phraseComponent.titlePhraseComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLETEXT) as IconProp}
                  onClickComponent={this.state.SampleTextComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.imageComponent.titleImageComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLEIMAGE) as IconProp}
                  onClickComponent={this.state.SampleImageComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.sampleVideo.titleSampleVideoComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLEVIDEO) as IconProp}
                  onClickComponent={this.state.SampleVideoComponent}
                />
                {/* <FormflowComponentItem
                                    title={I18n.l('formflow.components.audioComponent.titleAudioComponent')}
                                    icon={TaskIconDictionary.get(ComponentType.AUDIO) as IconProp}
                                />
                                <FormflowComponentItem
                                    title={I18n.l('formflow.components.videoComponent.titleVideoComponent')}
                                    icon={TaskIconDictionary.get(ComponentType.VIDEO) as IconProp}
                                /> */}

                <FormflowComponentItem
                  title={I18n.l('formflow.components.selectComponent.titleDateComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SELECT) as IconProp}
                  onClickComponent={this.state.SelectComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.treeView.title')}
                  icon={TaskIconDictionary.get(ComponentType.TREEVIEW) as IconProp}
                  onClickComponent={this.state.TreeViewComponent}
                />


                <FormflowComponentItem
                  title={I18n.l('formflow.components.sumComponent.titleSumComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SCORE) as IconProp}
                  onClickComponent={this.state.ScoreComponent}
                />

                <FormflowComponentItem
                  title={I18n.l('formflow.components.goToComponent.titleGoToComponent')}
                  icon={TaskIconDictionary.get(ComponentType.GOTO) as IconProp}
                  onClickComponent={this.state.GoToComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.sampleComponent.titleSampleComponent')}
                  icon={TaskIconDictionary.get(ComponentType.SAMPLE) as IconProp}
                  onClickComponent={this.state.SampleComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.calculatorComponent.title')}
                  icon={TaskIconDictionary.get(ComponentType.CALCULATOR) as IconProp}
                  onClickComponent={this.state.CalculatorComponent}
                />
                <FormflowComponentItem
                  title={I18n.l('formflow.components.drawComponent.titleDrawComponent')}
                  icon={TaskIconDictionary.get(ComponentType.DRAW) as IconProp}
                  onClickComponent={this.state.DrawComponent}
                />
                {/* <FormflowComponentItem
                  title={I18n.l('formflow.components.matrixComponent.titleMatrixComponent')}
                  icon={TaskIconDictionary.get(ComponentType.MATRIX) as IconProp}
                /> */}
              </Col>
            </Row>
          )}
        </FormflowContext.Consumer>
      </LateralMenuWrapper >
    )
  }
}

const LateralMenuWrapper = styled.div`
height: 100vh;
width: auto;
position: fixed;
overflow: auto;     
    .row{
        height: 100%;
    }
    .lateralComponentsMenu{
        padding: 25px 15px 10px 15px;
        
        height:100%;
        background-color: ${Theme.secondary.supahLightGrey};
        -webkit-box-shadow: 3px 0 15px ${Theme.secondary.lightGrey};
        box-shadow: 3px 0 15px ${Theme.secondary.lightGrey};                
    }  
          
`